import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ReturnToSport() {
  useEffect(() => {
    document.title = "Return-to-Sport Rehabilitation | Viksha Health Care";
    const newMetaDescription =
      "Return-to-sport rehabilitation at Viksha Health Care. Build strength, mobility, and confidence with a safe, stepwise return-to-play plan.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Return-to-Sport Rehabilitation</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Return-to-Sport-Rehabilitation.avif" />
        </div>
        <div className="textareaofser">
          <h1>Return-to-Sport Rehabilitation</h1>

          <p>
            Return-to-sport rehabilitation is a structured program designed to
            help individuals safely resume physical activity after an injury.
            The focus is on restoring strength, flexibility, balance, and
            confidence while reducing the risk of re-injury.
          </p>

          <p>
            Whether you are a professional athlete or someone who enjoys regular
            exercise, a gradual and supervised return to activity is essential
            for full recovery.
          </p>

          <h5>Goals of Return-to-Sport Rehabilitation</h5>
          <ul>
            <li>Restore joint movement and flexibility</li>
            <li>Rebuild muscle strength and endurance</li>
            <li>Improve balance and coordination</li>
            <li>Regain sport-specific skills and confidence</li>
            <li>Reduce the risk of future injuries</li>
          </ul>

          <h5>Phases of Rehabilitation</h5>

          <h6>Early Recovery Phase</h6>
          <p>
            The initial phase focuses on reducing pain and swelling while gently
            restoring basic movement and muscle activation.
          </p>

          <h6>Strength and Conditioning Phase</h6>
          <p>
            As healing progresses, exercises are introduced to strengthen
            muscles, improve joint stability, and enhance overall fitness.
          </p>

          <h6>Sport-Specific Training Phase</h6>
          <p>
            Later stages of rehabilitation include drills that mimic the
            movements of your specific sport, helping your body adapt to
            real-life activity demands.
          </p>

          <h5>Monitoring Progress</h5>
          <p>
            Progress is regularly assessed to ensure that strength, flexibility,
            and stability have recovered adequately before returning to full
            activity.
          </p>

          <h5>Safe Return to Activity</h5>
          <p>
            Returning to sport too early can increase the risk of re-injury. A
            gradual, step-by-step progression helps ensure that your body is
            ready for the physical demands of your sport.
          </p>

          <h5>Who Benefits from Return-to-Sport Rehabilitation?</h5>
          <ul>
            <li>Individuals recovering from ligament or muscle injuries</li>
            <li>Patients after orthopaedic surgeries</li>
            <li>People with recurrent sports-related pain</li>
            <li>Athletes returning after fractures or joint injuries</li>
          </ul>

          <p>
            Proper rehabilitation not only supports recovery but also improves
            overall performance and confidence when returning to sports and
            physical activities.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(ReturnToSport);
